<template>
  <v-container fluid>
    <Submenu
        v-bind:title="'Feeds'"
        v-bind:right_buttons="submenu_btns"
        v-on:menu-click="menu_click"
        v-bind:showSearch="true"
        v-on:search="search_change"
    />

    <v-btn absolute fab :right="!isRtl" :left="isRtl"
      color="primary" class="mx-6 mt-n2" @click.stop="showDialog=true" :key="feedKey">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <BuyFeedDialog v-model="showDelivery" v-bind:feedId="null" v-on:close="closeDelivery" v-bind:show="true" />
    <AddEditFeed v-model="showDialog" v-bind:feedId="null" v-on:close="close" />
    <v-layout wrap>
      <v-flex mb-4 mr-2 xs12 sm6 md4 xl2 v-for="f in feeds" v-bind:key=f.Id>
        <FeedPanel v-bind:feedId="f.Id" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AddEditFeed from "../components/AddEditFeed";
import FeedPanel from "@/components/FeedPanel";
import BuyFeedDialog from "@/components/BuyFeed";
import Submenu from '../components/common/submenu.vue';

export default {
  data: function () {
    return {
      showDialog: false,
      showDelivery: false,
      feedKey: 0,
      search: '',
      submenu_btns: [
        {
          index: 0,
          text: "",
          icon: "mdi-truck-delivery",
          tooltip: this.$i18n.t('Accept Feed Delivery')
        },
        {
          index: 1,
          text: "",
          icon: "mdi-checkbox-multiple-marked-outline",
          tooltip: this.$i18n.t('Stocktaking')
        }
      ]
    }
  },
  components: {
    AddEditFeed,
    FeedPanel,
    BuyFeedDialog,
    Submenu
  },
  computed: {
    feeds() {
      return this.$store.getters.getFeeds(this.search);
    },
    isRtl: function() {
      //make drawer on right for he locale
      return this.$i18n.locale == "he";
    },
  },
  methods: {
    menu_click: function(btnIndex) {
      if (btnIndex == 0)
        this.showDelivery=true;
      if (btnIndex == 1)
        this.$router.push('inventory');

    },
    search_change(event) {
      this.search = event;
    },
    close() {
      this.feedKey++;
      this.showDialog = false;
    },
    closeDelivery() {
      this.showDelivery= false;
    }
  }
}
</script>

<style>

</style>

